<template>
  <div>
    <div class="bgtopmessage">
      <div class="topmessage" v-if="!isUploadZx">
        <div class="toptips">请上传征信获取完整企业报告</div>
        <div class="topbtn">
          <van-button round type="info" icon="plus" size="small" @click="showUploadHandle">上传征信</van-button>
        </div>
      </div>
      <div class="topmessage" v-else>
        <div class="toptips">征信信息已上传，请点击查看</div>
        <div class="topbtn">
          <van-button round type="info" size="small" :to="'/credit/pdf?id=' + reportId">查看征信</van-button>
        </div>
        <div class="topbtn">
          <van-button round type="info" icon="plus" size="small" @click="showUploadHandle">更新征信</van-button>
        </div>
      </div>
    </div>

    <!-- 从手机相册选择弹框 -->
    <van-popup v-model="visible" position="bottom">
      <div class="uploadview">
        <van-form>
          <van-field name="radio" label="文件类型">
            <template #input>
              <van-radio-group v-model="IsFirm" direction="horizontal">
                <van-radio name="true">企业</van-radio>
                <van-radio name="false">个人</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="passWord" type="password" label="文件密码" placeholder="请输入密码没有可不填" />
          <van-field label="跳过强校验">
            <template #input>
              <van-switch v-model="skipCheck" size="24" />
            </template>
          </van-field>
          <p class="tips2"><van-icon name="warning-o" /> 聊天记录的PDF文件需先保存至手机</p>
          <van-button icon="plus" round type="info" block @click="selectFromAlbum">上传PDF文件</van-button>
        </van-form>
      </div>
    </van-popup>

    <!-- 文件选择弹框 -->
    <van-popup v-model="pickerVisible" position="bottom" round>
      <div class="picker-content">
        <div class="picker-title">选择文件来源</div>
        <div class="picker-buttons">
          <div class="picker-button" @click="showAlbumPicker">从手机相册选择</div>
          <div class="picker-button mini-program-btn" v-if="isWeChat">
            <wx-open-launch-weapp id="launch-btn" :appid="miniProgramAppId" :path="miniProgramPath"
              env-version="release" @launch="onLaunchMiniProgram" @error="onLaunchError">
              <script type="text/wxtag-template">
                <style>.btn { width: 100%; height: 100%; min-height: 44px; display: flex; align-items: center; justify-content: center; font-size: 15px; color: #333; background: transparent; border: none; line-height: 1; text-align: center; padding: 0; margin: 0; }</style>
                <div class="btn">从小程序选择文件</div>
              </script>
            </wx-open-launch-weapp>
            <!-- 备用按钮 -->
            <div class="mini-program-fallback" @click="retryWxInit">
              从小程序选择文件
            </div>
          </div>
          <div class="picker-button cancel" @click="pickerVisible = false">取消</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import axios from 'axios'
import user from '@/utils/user'
import wx from "weixin-js-sdk"
import request from "@/utils/request";
import wxLogin from '@/utils/wx';

console.log('微信 JS-SDK 库是否加载:', typeof wx !== 'undefined');
console.log('当前环境是否为微信:', /MicroMessenger/i.test(navigator.userAgent));

export default {
  props: {
    isUploadZx: {
      type: Boolean,
      value: false,
    },
    reportId: {
      type: String,
      value: "",
    }
  },
  data() {
    return {
      visible: false,
      pickerVisible: false,
      passWord: "",
      IsFirm: "true",
      skipCheck: false,
      miniProgramAppId: 'wx027ce2541bc5914c',
    }
  },
  computed: {
    miniProgramPath() {
      // 小程序文件上传页面路径，只传reportId和回调地址，企业/个人和密码在小程序端填写
      const backUrl = encodeURIComponent(window.location.href.split('?')[0]);
      return `/pages/fileUpload/fileUpload?reportId=${this.reportId}&backUrl=${backUrl}`;
    },
    isWeChat() {
      return /MicroMessenger/i.test(navigator.userAgent);
    }
  },
  created() {
    // 检查是否在微信环境中
    console.log('当前是否为微信环境:', this.isWeChat);

    if (this.isWeChat) {
      // 初始化微信 JS-SDK
      this.initWxSDK();
    } else {
      console.log('非微信环境，跳过微信 JS-SDK 初始化');
    }
  },
  mounted() {
    if (this.isIOS() && !sessionStorage.getItem('iosRefreshed')) {
      sessionStorage.setItem('iosRefreshed', 'true');
      window.location.reload();
    }
  },
  beforeDestroy() {
    sessionStorage.setItem('iosRefreshed', 'false');
  },
  methods: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    initChooseFile(data) {
      console.log('初始化微信 JS-SDK 参数:', data);

      const appId = wxLogin.getAPPID();
      console.log('获取到的 AppID:', appId);

      // 获取当前页面的 URL 作为参数，不包含 # 后面的部分
      const currentUrl = window.location.href.split('#')[0];
      console.log('当前页面 URL:', currentUrl);

      wx.config({
        debug: false, // 关闭调试模式
        appId: appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名
        jsApiList: ['chooseMessageFile'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 开放标签列表
      });

      wx.ready(() => {
        console.log('微信 JS-SDK 初始化成功');
        // 微信 JS-SDK 初始化成功后，重新渲染开放标签
        this.$nextTick(() => {
          this.refreshWxOpenTag();
        });
      });

      wx.error((res) => {
        console.error('微信 JS-SDK 初始化失败:', res);
        console.error('当前 URL:', currentUrl);
        console.error('使用的 AppID:', appId);
        console.error('签名参数:', {
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature
        });
        // 尝试重新获取签名并初始化
        // setTimeout(() => {
        //   this.initWxSDK();
        // }, 1000);
      });
    },
    showUploadHandle() {
      this.pickerVisible = true;
      // 每次打开文件选择器时，重新初始化微信开放标签
      if (this.isWeChat) {
        this.$nextTick(() => {
          this.refreshWxOpenTag();
        });
      }
    },
    // 点击"从手机相册选择"，打开相册选择弹框
    showAlbumPicker() {
      this.pickerVisible = false;
      this.passWord = "";
      this.IsFirm = "true";
      this.skipCheck = false;
      this.visible = true;
    },
    // 点击"上传PDF文件"按钮，执行文件选择
    selectFromAlbum() {
      this.visible = false;
      // 触发文件输入框，让用户从相册选择文件
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/pdf';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          this.afterRead({ file });
        }
      };
      input.click();
    },
    // 小程序开放标签 - 跳转成功
    onLaunchMiniProgram(e) {
      console.log('跳转小程序成功', e);
      this.pickerVisible = false;
    },
    // 小程序开放标签 - 跳转失败
    onLaunchError(e) {
      console.error('跳转小程序失败:', e);
      Toast('跳转小程序失败，请重试');
    },
    // 重新初始化微信 JS-SDK
    retryWxInit() {
      Toast.loading({
        message: '初始化微信功能中...',
        forbidClick: true,
      });
      this.initWxSDK();
      setTimeout(() => {
        Toast.clear();
        window.location.reload();
        Toast('初始化完成，请再次点击');
      }, 1500);
    },
    // 刷新微信开放标签
    refreshWxOpenTag() {
      if (typeof wx !== 'undefined' && wx.invoke) {
        console.log('刷新微信开放标签');
        // 尝试调用一个无关的方法来触发开放标签的重新渲染
        wx.invoke('getNetworkType', {}, function () { });
      }
    },
    // 初始化微信 JS-SDK
    initWxSDK() {
      // 获取当前页面的 URL 作为参数，不包含 # 后面的部分
      const currentUrl = window.location.href.split('#')[0];
      console.log('当前页面 URL:', currentUrl);

      request.get("/Data/WeChat/GetGZHSign", { params: { url: currentUrl } }).then((res) => {
        console.log('签名接口返回数据:', res);
        if (res.data && res.data.data) {
          this.initChooseFile(res.data.data);
        } else {
          console.error('签名接口返回数据格式错误:', res);
          Toast('微信功能初始化失败，请重试');
        }
      }).catch((error) => {
        console.error('获取签名失败:', error);
        Toast('微信功能初始化失败，请重试');
      });
    },
    uploadFile(file) {
      Toast.loading({
        message: '正在上传...',
        forbidClick: true,
      });

      const formData = new FormData();
      formData.append('file', file);
      formData.append('Id', this.reportId);
      formData.append('passWord', this.passWord);
      formData.append('IsFirm', this.IsFirm);
      formData.append('skipCheck', this.skipCheck);

      axios.post(process.env.VUE_APP_BASE_API + '/Data/ReportTask/UploadFile', formData, {
        headers: {
          'Authorization': user.getCacheToken()
        }
      }).then(res => {
        Toast.clear();
        console.log(res);
        if (res.data.code === 98) {
          Toast(res.data.message);
        } else {
          this.visible = false;
          this.pickerVisible = false;
          this.$emit('reloadDetail');
        }
      }).catch(res => {
        Toast.clear();
        console.log(res);
      })
    },
    afterRead(file) {
      console.log('选中文件:', file);
      this.uploadFile(file.file);
    }
    // #end
  }
}
</script>

<style lang="less" scoped>
/* top tips */
.bgtopmessage {
  position: relative;
  height: 3rem;
  background: #176FCA;
  display: flex;
  padding: 12px;
}

.topmessage {
  position: relative;
  height: 3rem;
  background: #3A84D1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;
}

.toptips {
  line-height: 3rem;
  font-size: .8rem;
  color: #fff;
  padding-left: 0;
}

.topbtn {
  position: relative;
  right: 0;
  top: 0;
}

.topbtn .van-button {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 6px;
}

.topbtn .van-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
}

/* 上传PDF文件按钮 */
.uploadview .van-button {
  background: #176FCA;
  border-color: #176FCA;
  color: #fff;
}

.uploadview .van-button:hover {
  background: #145EAB;
  border-color: #145EAB;
}

.box {
  padding: 32rpx;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.uploadview {
  padding: 20px;
}

.upbtn {
  margin-top: 30px;
}

.tips2 {
  font-size: 13px;
  color: #777;
  line-height: 30px;
}

/* 文件选择弹框样式 */
.picker-content {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px 12px 0 0;
}

.picker-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.picker-buttons {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #F0F4FF;
  border-radius: 8px;
  overflow: hidden;
}

.picker-button {
  background: #ffffff;
  padding: 15px;
  text-align: center;
  font-size: 15px;
  color: #333;
  transition: background-color 0.3s;

  &:hover {
    background-color: #F0F4FF;
  }

  &.cancel {
    margin-top: 10px;
    color: #999;
  }

  &.mini-program-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;

    wx-open-launch-weapp {
      display: block;
      width: 100%;
      height: 100%;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 2;
    }

    .mini-program-fallback {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      color: #333;
      z-index: 1;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.3s;
    }

    /* 当微信开放标签加载失败时，显示备用按钮 */
    wx-open-launch-weapp:not(:defined)+.mini-program-fallback {
      opacity: 1;
      pointer-events: auto;
    }
  }
}
</style>